import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  response: null,
  loading: false,
  error: null,
  message: '',
  data: [],
};

export const serviceSlice = createSlice({
  name: 'serviceSlice',
  initialState,
  reducers: {
    addService: () => {},
    getService: () => {},
    getOneService: () => {},
    updateService: () => {},
    removeService: () => {},
    successService: (state, action) => {
      state.data = action.payload;
    },
    failedService: (state, action) => {
      state.error = action.payload;
    },
  },
});

export const {
  addService,
  getService,
  getOneService,
  updateService,
  removeService,
  successService,
  failedService,
} = serviceSlice.actions;

export default serviceSlice.reducer;
